
























































import Vue from "vue";
export default Vue.extend({
  name: "AppCard",
  props: {
    data: { type: Object }
  },
  computed: {
    statusColor() {
      if (!this.data) return "";

      if (!(this.data as any).status.readyReplicas) {
        return "red";
      } else if (
        (this.data as any).status.readyReplicas ===
        (this.data as any).spec.replicas
      ) {
        return "green";
      } else {
        return "orange";
      }
    },
    statusCode() {
      if (!this.data) return "";
      return this.data.metadata.name.slice(0, 2).toUpperCase();
    }
  },
  methods: {
    handleCommand(type: string, data: any) {
      // 事件返回上层处理
      this.$emit("event", { type, data });
    }
  }
});
